// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Css from "bs-css-emotion/src/Css.bs.js";
import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as I18next$LiveRoom from "../../bindings/I18next.bs.js";
import * as CommonStyles$LiveRoom from "../../styles/CommonStyles.bs.js";
import * as Utils_Breakpoints$LiveRoom from "../../Utils/Utils_Breakpoints.bs.js";
import * as SterlingTypography$LiveRoom from "../../bindings/SterlingTypography.bs.js";

var fadeIn = Curry._1(Css.style, {
      hd: Css.animationDuration({
            NAME: "ms",
            VAL: 1000
          }),
      tl: {
        hd: Css.animationTimingFunction("ease"),
        tl: {
          hd: Css.animationName(Curry._1(Css.keyframes, {
                    hd: [
                      0,
                      {
                        hd: Css.marginTop(Css.px(20)),
                        tl: {
                          hd: Css.opacity(0.0),
                          tl: /* [] */0
                        }
                      }
                    ],
                    tl: {
                      hd: [
                        100,
                        {
                          hd: Css.marginTop("zero"),
                          tl: {
                            hd: Css.opacity(1.0),
                            tl: /* [] */0
                          }
                        }
                      ],
                      tl: /* [] */0
                    }
                  })),
          tl: /* [] */0
        }
      }
    });

var fadeOut = Curry._1(Css.style, {
      hd: Css.opacity(0.0),
      tl: {
        hd: Css.animationDuration({
              NAME: "ms",
              VAL: 1000
            }),
        tl: {
          hd: Css.animationTimingFunction("ease"),
          tl: {
            hd: Css.animationName(Curry._1(Css.keyframes, {
                      hd: [
                        0,
                        {
                          hd: Css.marginTop("zero"),
                          tl: {
                            hd: Css.opacity(1.0),
                            tl: /* [] */0
                          }
                        }
                      ],
                      tl: {
                        hd: [
                          100,
                          {
                            hd: Css.marginTop(Css.px(20)),
                            tl: {
                              hd: Css.opacity(0.0),
                              tl: /* [] */0
                            }
                          }
                        ],
                        tl: /* [] */0
                      }
                    })),
            tl: /* [] */0
          }
        }
      }
    });

var Animations = {
  fadeIn: fadeIn,
  fadeOut: fadeOut
};

function SecretLoader(props) {
  var match = I18next$LiveRoom.useTranslation(undefined);
  var t = match.t;
  var breakpoint = Utils_Breakpoints$LiveRoom.useBreakpoint(undefined);
  return React.createElement("div", {
              className: Curry._1(Css.merge, {
                    hd: Curry._1(Css.style, {
                          hd: Css.display("flex"),
                          tl: {
                            hd: Css.flexDirection("column"),
                            tl: {
                              hd: Css.alignItems("center"),
                              tl: {
                                hd: Css.justifyContent("center"),
                                tl: {
                                  hd: Css.position("absolute"),
                                  tl: {
                                    hd: Css.top(Css.pct(50)),
                                    tl: {
                                      hd: Css.left(Css.pct(50)),
                                      tl: {
                                        hd: Css.transform(Css.translate(Css.pct(-50), Css.pct(-50))),
                                        tl: {
                                          hd: CommonStyles$LiveRoom.mediaV2(/* Mobile */1, {
                                                hd: Css.width(Css.pct(80)),
                                                tl: /* [] */0
                                              }),
                                          tl: /* [] */0
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }),
                    tl: {
                      hd: props.loading ? fadeIn : fadeOut,
                      tl: /* [] */0
                    }
                  })
            }, React.createElement("img", {
                  className: Curry._1(Css.style, {
                        hd: Css.width(Css.px(180)),
                        tl: /* [] */0
                      }),
                  src: "/buy/static/img/sealed-logo.png"
                }), breakpoint === /* Mobile */1 ? React.createElement(SterlingTypography$LiveRoom.Headline28Regular.make, {
                    className: Curry._1(Css.style, {
                          hd: Css.marginTop(Css.px(32)),
                          tl: {
                            hd: Css.textAlign("center"),
                            tl: /* [] */0
                          }
                        }),
                    children: Curry._1(t, "SecretAuctions_Loader_Title")
                  }) : React.createElement(SterlingTypography$LiveRoom.Headline48Regular.make, {
                    className: Curry._1(Css.style, {
                          hd: Css.marginTop(Css.px(32)),
                          tl: {
                            hd: Css.textAlign("center"),
                            tl: /* [] */0
                          }
                        }),
                    children: Curry._1(t, "SecretAuctions_Loader_Title")
                  }));
}

var make = SecretLoader;

export {
  Animations ,
  make ,
}
/* fadeIn Not a pure module */
